import {lazy} from "../../lib/lazy.js";
export const packageSubscriptionRoutes = [
  {
    path: "/package-subscription-price",
    component: lazy(() => import(/* webpackChunkName: "packageSubscriptionRoutes" */ "../../views/package-subscription/index.js"))
  },
  {
    path: "/pay-subscription-results",
    component: lazy(() => import(/* webpackChunkName: "packageSubscriptionRoutes" */ "../../views/package-subscription/pay-subscription-results.js"))
  },
  {
    path: "/pay-subscription-results-auth",
    component: lazy(() => import(/* webpackChunkName: "packageSubscriptionRoutes" */ "../../views/package-subscription/pay-subscription-results-auth.js"))
  },
  {
    path: "/pay-subscription-success",
    component: lazy(() => import(/* webpackChunkName: "packageSubscriptionRoutes" */ "../../views/package-subscription/pay-subscription-success.js"))
  },
  {
    path: "/pay-subscription-error",
    component: lazy(() => import(/* webpackChunkName: "packageSubscriptionRoutes" */ "../../views/package-subscription/pay-subscription-error.js"))
  },
  {
    path: "/pay-subscription-undone",
    component: lazy(() => import(/* webpackChunkName: "packageSubscriptionRoutes" */ "../../views/package-subscription/pay-subscription-undone.js"))
  },
  {
    path: "/transaction-record",
    component: lazy(() => import(/* webpackChunkName: "packageSubscriptionRoutes" */ "../../views/package-subscription/transaction-record.js"))
  }
];
